import { Directive, ElementRef } from "@angular/core";

@Directive({
  selector: '[mrt-insights-section]'
})
export class DetailsPageSectionDirective {
  constructor ( public element: ElementRef ) {

  }
}
